// Modules
import React from 'react';
import PropTypes from "prop-types";
import cx from 'classnames';

// Components
import Breadcrumbs from '../breadcrumbs';
import CustomGatsbyImage from '../gatsbyImage';

// Styles
import * as styles from './hero.module.scss';

const Hero = (props) => {
  const {
    breadcrumbs,
    className,
    contentClassName,
    imageClassName,
    image,
    subTitle,
    title
  } = props;
  const wrapperClassName = cx(styles.heroWrapper);
  const contentClass = cx(styles.content, contentClassName);

  return (
    <div className={wrapperClassName}>
      <CustomGatsbyImage
        alt="hero-back"
        imgClassName={imageClassName}
        img={image?.asset}
      />
      <div className={cx(styles.contentWrapper, className)}>
        <div className={contentClass}>
          {breadcrumbs && <Breadcrumbs links={breadcrumbs}/>}
          <h1 className={styles.heading}>
            <mark style={{ backgroundColor: '#e6195e', color: 'white', WebkitBoxDecorationBreak: 'clone', padding: '6px 16px' }}>{title}</mark>
          </h1>
          {subTitle && (
            <p className={styles.subHeading}>
              <mark
                style={{
                  backgroundColor: '#222c3b',
                  color: 'white',
                  WebkitBoxDecorationBreak: 'clone',
                  padding: '5px 14px', // Adjust padding for subtitle if needed
                }}
              >
                {subTitle}
              </mark>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

Hero.propTypes = {
  breadcrumbs: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  image: PropTypes.shape({
    url: PropTypes.string,
  }).isRequired,
  imageClassName: PropTypes.string,
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  title: PropTypes.string,
};

Hero.defaultProps = {
  breadcrumbs: false,
  className: '',
  contentClassName: '',
  imageClassName: '',
  subTitle: '',
  title: '',
};

export default Hero;


